var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queue-error-toast",on:{"click":_vm.resetError}},[_vm._v("\n  "+_vm._s(_vm.$t('errors.title'))+"\n  "),_c('br'),_vm._v("\n  ("+_vm._s(_vm.error)+")\n")])}
var staticRenderFns = []

export { render, staticRenderFns }